const getRoleRank = (rank: string): number => {
  switch (rank) {
    case "admin":
      return 3;
    case "manager":
      return 2;
    case "viewer":
      return 1;
    default:
      return 0;
  }
};

export const hasPermission = (has: string, needs: string) => {
  return getRoleRank(has) >= getRoleRank(needs);
};
